import { useEffect, useState, useCallback } from 'react'
import { isEqual } from 'lodash'

import { getIcpModuleDataForHarri } from './ICP.harri.util'
import { ICPFilters } from '../../../@types/module'
import { useIcpModuleForHarriLazyQuery, order_by } from '../../../graphql/__generated__/harri_graphql'

const useGraphQL = () => {
  const [filters, setFilters] = useState<ICPFilters>({})
  const [loadIcpModuleData, { data, loading }] = useIcpModuleForHarriLazyQuery()

  const changeFilters = useCallback((_filters: ICPFilters) => {
    if (!isEqual(_filters, filters)) {
      setFilters(_filters)
    }
  }, [filters])

  useEffect(() => {
    const where = {
      "isdeleted": {
        "_eq": false
      }
    }

    const orderBy = {
      "account_module_static": {
        "predct_proba": order_by.desc_nulls_last
      }
    }

    if (!data) {
      loadIcpModuleData({
        variables: { where, orderBy, limit: 1000 }
      })
    }
  }, [data, loadIcpModuleData])

  return {
    filters,
    setFilters: changeFilters,
    icpModuleData: getIcpModuleDataForHarri(data, filters),
    isLoading: loading,
  }
}

export default useGraphQL
